var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _g, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBoard1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 299,
    height: 178,
    viewBox: "0 0 299 178",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M291.072 0H7.92788C3.54943 0 0 2.8886 0 6.45187V171.548C0 175.111 3.54943 178 7.92788 178H291.072C295.451 178 299 175.111 299 171.548V6.45187C299 2.8886 295.451 0 291.072 0Z",
    fill: "#00A90B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M288.68 167.828V10.3984L10.3897 10.3984V167.828L288.68 167.828Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.52,
    d: "M263.71 43.6797H128.41V139.65H263.71V43.6797Z",
    fill: "#EDEDED"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M36.7797 43.5312H33.4297V47.0613H36.7797V43.5312Z",
    fill: "#00A90B"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M91.9596 43.5312H39.3896V47.0613H91.9596V43.5312Z",
    fill: "#DEDEDE"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M36.7797 52.1797H33.4297V55.7097H36.7797V52.1797Z",
    fill: "#00A90B"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M91.9596 52.1797H39.3896V55.7097H91.9596V52.1797Z",
    fill: "#DEDEDE"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M36.7797 60.8281H33.4297V64.3581H36.7797V60.8281Z",
    fill: "#00A90B"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M99.9596 60.8281H39.3896V64.3581H99.9596V60.8281Z",
    fill: "#DEDEDE"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M67.6796 69.4688H39.3896V72.9987H67.6796V69.4688Z",
    fill: "#DEDEDE"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M61.7197 107.031H33.4297V110.561H61.7197V107.031Z",
    fill: "#DEDEDE"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M92.9397 115.672H33.4297V119.202H92.9397V115.672Z",
    fill: "#DEDEDE"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.45
  }, /*#__PURE__*/React.createElement("path", {
    d: "M263.479 50.3828H128.409",
    stroke: "#B4B4B4",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.479 59.5391H128.409",
    stroke: "#B4B4B4",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.479 68.7031H128.409",
    stroke: "#B4B4B4",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.479 77.8516H128.409",
    stroke: "#B4B4B4",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.479 87.0156H128.409",
    stroke: "#B4B4B4",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.479 96.1719H128.409",
    stroke: "#B4B4B4",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.479 105.32H128.409",
    stroke: "#B4B4B4",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.479 114.484H128.409",
    stroke: "#B4B4B4",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.479 123.641H128.409",
    stroke: "#B4B4B4",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.479 132.805H128.409",
    stroke: "#B4B4B4",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }))), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M157.03 84.0175C157.03 86.6875 154.87 88.8475 152.2 88.8475C149.53 88.8475 147.37 86.6875 147.37 84.0175C147.37 81.3475 149.53 79.1875 152.2 79.1875C154.87 79.1875 157.03 81.3475 157.03 84.0175Z",
    fill: "#00A90B"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M152.22 121.468V86.0781",
    stroke: "#00A90B",
    strokeWidth: 0.27,
    strokeMiterlimit: 10
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M221.18 110.773V64.0234",
    stroke: "#00A90B",
    strokeWidth: 0.27,
    strokeMiterlimit: 10
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M186.75 98.9106V78.8906",
    stroke: "#00A90B",
    strokeWidth: 0.27,
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M264.479 139.397V96.2975L244.509 114.237L221.159 111.188L210.069 95.4375L196.399 106.107L186.749 98.1875L162.359 114.237L152.199 121.467L142.029 105.597L128.409 124.908V139.397H264.479Z",
    fill: "#F1F1F1"
  }))), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M141.92 107.118C142.947 107.118 143.78 106.286 143.78 105.258C143.78 104.231 142.947 103.398 141.92 103.398C140.892 103.398 140.06 104.231 140.06 105.258C140.06 106.286 140.892 107.118 141.92 107.118Z",
    fill: "#A6A6A6"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M164.22 115.063C164.22 116.093 163.39 116.923 162.36 116.923C161.33 116.923 160.5 116.093 160.5 115.063C160.5 114.033 161.33 113.203 162.36 113.203C163.39 113.203 164.22 114.033 164.22 115.063Z",
    fill: "#A6A6A6"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M198.27 106.11C198.27 107.14 197.44 107.97 196.41 107.97C195.38 107.97 194.55 107.14 194.55 106.11C194.55 105.08 195.38 104.25 196.41 104.25C197.44 104.25 198.27 105.08 198.27 106.11Z",
    fill: "#A6A6A6"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M154.06 121.469C154.06 122.499 153.23 123.329 152.2 123.329C151.17 123.329 150.34 122.499 150.34 121.469C150.34 120.439 151.17 119.609 152.2 119.609C153.23 119.609 154.06 120.439 154.06 121.469Z",
    fill: "#00A90B"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M188.61 98.1881C188.61 99.2181 187.78 100.048 186.75 100.048C185.72 100.048 184.89 99.2181 184.89 98.1881C184.89 97.1581 185.72 96.3281 186.75 96.3281C187.78 96.3281 188.61 97.1581 188.61 98.1881Z",
    fill: "#00A90B"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M211.93 95.4381C211.93 96.4681 211.1 97.2981 210.07 97.2981C209.04 97.2981 208.21 96.4681 208.21 95.4381C208.21 94.4081 209.04 93.5781 210.07 93.5781C211.1 93.5781 211.93 94.4081 211.93 95.4381Z",
    fill: "#A6A6A6"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M246.379 114.243C246.379 115.273 245.549 116.103 244.519 116.103C243.489 116.103 242.659 115.273 242.659 114.243C242.659 113.213 243.489 112.383 244.519 112.383C245.549 112.383 246.379 113.213 246.379 114.243Z",
    fill: "#00A90B"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M223.02 111.188C223.02 112.218 222.19 113.048 221.16 113.048C220.13 113.048 219.3 112.218 219.3 111.188C219.3 110.158 220.13 109.328 221.16 109.328C222.19 109.328 223.02 110.158 223.02 111.188Z",
    fill: "#00A90B"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M221.16 66.8084C223.828 66.8084 225.99 64.646 225.99 61.9784C225.99 59.3109 223.828 57.1484 221.16 57.1484C218.493 57.1484 216.33 59.3109 216.33 61.9784C216.33 64.646 218.493 66.8084 221.16 66.8084Z",
    fill: "#00A90B"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M244.54 113.522V95.8516",
    stroke: "#00A90B",
    strokeWidth: 0.27,
    strokeMiterlimit: 10
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M244.51 98.4022C247.177 98.4022 249.34 96.2397 249.34 93.5722C249.34 90.9047 247.177 88.7422 244.51 88.7422C241.842 88.7422 239.68 90.9047 239.68 93.5722C239.68 96.2397 241.842 98.4022 244.51 98.4022Z",
    fill: "#00A90B"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M191.58 74.7675C191.58 77.4375 189.42 79.5975 186.75 79.5975C184.08 79.5975 181.92 77.4375 181.92 74.7675C181.92 72.0975 184.08 69.9375 186.75 69.9375C189.42 69.9375 191.58 72.0975 191.58 74.7675Z",
    fill: "#00A90B"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M121.89 48.0625H117.64V52.3125H121.89V48.0625Z",
    fill: "#00A90B"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M121.89 66.5703H117.64V70.8203H121.89V66.5703Z",
    fill: "#00A90B"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M121.89 85.0625H117.64V89.3125H121.89V85.0625Z",
    fill: "#00A90B"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M121.89 103.562H117.64V107.812H121.89V103.562Z",
    fill: "#00A90B"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M121.89 123.062H117.64V127.312H121.89V123.062Z",
    fill: "#00A90B"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M264.479 139.66H128.409V43.6797",
    stroke: "#B4B4B4",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoard1);
export default __webpack_public_path__ + "static/media/board1.2e9869c238ff414321d4e4034b3c6e25.svg";
export { ForwardRef as ReactComponent };